import React from 'react';
import MolecularViewerApp from '../components/molecular-viewer/MolecularViewerApp';

/**
 * Molecular Viewer Page
 * 
 * This page integrates the Snorkle Molecular Viewer (formerly vibe-molecular-viewer)
 * into the main Snorkle react site. It provides an interactive 3D molecular visualization
 * tool with PyMOL-like commands and natural language processing.
 */
const MolecularViewerPage = () => {
  return (
    <div style={{ 
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      overflow: 'hidden',
      zIndex: 1  // Below modals and header but above normal content
    }}>
      <MolecularViewerApp />
    </div>
  );
};

export default MolecularViewerPage;


